import AFRAME from "aframe";
import jQuery from "jquery";

const $ = jQuery;

AFRAME.registerSystem('modal', {
    init: function () {
        this.modals = [];
    },
    registerModal: function (el) {
        this.modals.push(el);
    },
    unregisterModal: function (el) {
        const index = this.modals.indexOf(el);
        this.modals.splice(index, 1);
    },
    hideAll: function () {
        for (let modal of this.modals) {
            modal.components.modal.hide();
        }
    },
});

AFRAME.registerComponent('hide-modal', {
    dependencies: [],
    schema: {
        type: "string", default: ""
    },
    update: function (oldData) {
        const me = this;
    },
    init: function () {
        const me = this;

        const target = document.body.querySelector(this.data);

        me.el.addEventListener('click', function () {
            target.components.modal.hide();
        });
    },
});

AFRAME.registerComponent('toggle-modal', {
    dependencies: [],
    schema: {
        type: "string", default: ""
    },
    update: function (oldData) {
        const me = this;
    },
    init: function () {
        const me = this;

        const target = document.body.querySelector(this.data);

        target.addEventListener('modal.shown', function(event) {
            if (me.el.classList.contains('close_on_active')) {
                me.el.setAttribute('advanced-visible', false);
            }
        });
        target.addEventListener('modal.hidden', function(event) {
            if (me.el.classList.contains('close_on_active')) {
                me.el.setAttribute('advanced-visible', true);
            }
        });

        me.el.addEventListener('click', function () {
            target.components.modal.toggle();
        });
    },
});

AFRAME.registerComponent('modal', {
    dependencies: [],
    schema: {
        distance: {type: 'number', default: 1.5},
        showEffect: {type: 'string', default: 'scale'},
        hideEffect: {type: 'string', default: 'scale'},
        // initiallyOpen: {type:'boolean', default: false},
        initialPosition: {type: 'vec3', default: '0 1.6 -1.5'},
    },
    init: function () {
        const me = this;

        me.system = document.querySelector('a-scene').systems['modal'];
        me.animations = document.querySelector('a-scene').systems['animations'];
        me.positionSystem = document.querySelector('a-scene').systems['position'];
        me.system.registerModal(me.el);

        // if (me.data.initiallyOpen) {
        //     console.log('initiallyOpen -->', me.data);
        //     setTimeout(() => {
        //         me.positionInit();
        //     }, 500);
        // }
    },
    positionInit() {
        const me = this;
        me.positionSystem.nearPosition(me.el, me.data.distance, me.data.initialPosition);
        // me.animations.show(me.el, me.data.showEffect);
        me.animations.show(me.el, '');
        me.el.emit('modal.shown', {target: me}, true);
    },
    remove: function () {
        const me = this;
        me.system.unregisterModal(me.el);
    },
    show: function () {
        const me = this;

        me.system.hideAll();
        
        if (me.el.getAttribute('visible') === false) {
            

            // let toggles = $('[toggle-modal]');
            // for (let toggle of toggles) {
            //     if (toggle.components['toggle-modal'].data === '#' + me.el.id) {
            //         toggle.setAttribute('advanced-visible', false);
            //         console.log(toggle);
            //     }
            // }
            
            me.sendEventToHtmlDevComponents();

            me.positionSystem.beforeCameraClamped(me.el, me.data.distance);
            // me.animations.show(me.el, me.data.showEffect);
            me.animations.show(me.el, '');
            me.el.emit('modal.shown', {target: me}, true);

            // send to video-in-modal

            let videos = me.el.getElementsByTagName('a-video');

            if (videos.length > 0) {
                let videoEl = videos[0].getAttribute('material').src;
                videoEl.play();
            }
        }
    },
    hide: function () {
        const me = this;
        if (me.el.getAttribute('visible') === true) {
            // me.animations.hide(me.el, me.data.hideEffect);
            me.animations.hide(me.el, '');
            this.el.emit('modal.hidden', {target: me}, true);

            // let toggles = $('[toggle-modal]');
            // for (let toggle of toggles) {
            //     if (toggle.components['toggle-modal'].data === '#' + me.el.id) {
            //         toggle.setAttribute('advanced-visible', true);
            //     }
            // }

            // send to video-in-modal

            let videos = me.el.getElementsByTagName('a-video');

            if (videos.length > 0) {
                let videoEl = videos[0].getAttribute('material').src;
                videoEl.pause();

                // hack for rewind?
                videoEl.currentTime = 0;
            }
        }
    },
    toggle: function () {
        const me = this;
        if (me.el.getAttribute('visible') === true) {
            me.hide();
        } else {
            me.show();
        }
    },
    sendEventToHtmlDevComponents: function() {
        const me = this;

        let elements1 = me.el.querySelectorAll('a-html');
        let elements2 = me.el.querySelectorAll('[html-dev]');
        let elements = [...elements1, ...elements2];
        
        for (let element of elements) {
            element.components['html-dev'].enable();
        }
    }
});